/** Redirects a mistaken Home Screen install of `/signin` into Key Mail. */
export function redirectMisinstalledWebmailPwa(): void {
	if (typeof window === "undefined") return;

	const nav = navigator as Navigator & { standalone?: boolean };
	const installed =
		window.matchMedia("(display-mode: standalone)").matches ||
		window.matchMedia("(display-mode: fullscreen)").matches ||
		nav.standalone === true;

	if (!installed) return;

	const path = window.location.pathname;
	if (path === "/signin" || path === "/") {
		window.location.replace("/webmail/");
	}
}
